import React, { useEffect, useState } from "react";
import i18n from "i18next";

import { fetchWrapper } from "../../helpers/fetchwrapper";

import useWindowSize from "../../helpers/useWindowSize";
import {
  baseUrl,
  DayPickerStringsDE,
  DayPickerStringsEN,
} from "../../helpers/constants";
import { IAcademyDocumentFolder } from "../../Models/IAcademyDocumentFolder";
import { IAppUserDto } from "../../Models/IAppUserDto";
import ReactQuill from "react-quill";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
  Dropdown,
  Option,
  Field,
} from "@fluentui/react-components";
import LuebPersonaPicker from "../../Controls/LuebPersonaPicker";
import { DatePicker } from "@fluentui/react-datepicker-compat";

interface IAddAcademyFolderDialogProps {
  isDialogOpen: boolean;
  onDismiss: any;
  onSaved: any;
  currentUser?: IAppUserDto;
  luebUsers: IAppUserDto[];
  copyOfAcademyFolder: IAcademyDocumentFolder | undefined;
  updateAcademyFolder: IAcademyDocumentFolder | undefined;
}

const modules = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] },
      ],
      ["clean"],
    ],
  },
  clipboard: { matchVisual: false },
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "list",
  "bullet",
  "indent",
  "align",
];

function AddOrUpdateAcademyFolderDialog(props: IAddAcademyFolderDialogProps) {
  const [academyDocumentFolder, setAcademyDocumentFolder] = useState<
    IAcademyDocumentFolder | undefined
  >({
    category: "bohrtechnik",
    trainingDateFrom: new Date(),
    suggestedRefreshDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() + 1
    ),
    trainingDateTo: new Date(
      new Date().getFullYear() + 1,
      new Date().getMonth(),
      new Date().getDate()
    ),
    trainerGuid: props.currentUser?.id ? props.currentUser?.id : "",
  });

  const handleAcademyDocumentFolderValuesChange = (name: string, val: any) => {
    setAcademyDocumentFolder((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const windowSize = useWindowSize();

  const addOrUpdateAcademyFolder = () => {
    if (academyDocumentFolder) {
      academyDocumentFolder.trainer = [];
      academyDocumentFolder.academyDocumentFolder2AppUsers = [];
      academyDocumentFolder.academyDocumentFolder2UserDocuments = [];

      fetchWrapper
        .postWithAuth(
          `${baseUrl}/api/academy/AddOrUpdateAcademyDocumentFolder?copyOfFolder=${props.copyOfAcademyFolder?.guid}`,
          academyDocumentFolder
        )
        .then(() => {
          props.onSaved();
        });
    }
  };

  // const addAcademyFolderDialogProps = {
  //   type: DialogType.largeHeader,
  //   title: academyDocumentFolder?.guid
  //     ? i18n.t<string>("updateAcademyFolderDialogTitle")
  //     : i18n.t<string>("addAcademyFolderDialogTitle"),
  //   subText: academyDocumentFolder?.guid
  //     ? i18n.t<string>("updateAcademyFolderDialogText")
  //     : i18n.t<string>("addAcademyFolderDialogText"),
  // };

  useEffect(() => {
    if (academyDocumentFolder?.trainingDateFrom) {
      const trainingDateTo = new Date(academyDocumentFolder?.trainingDateFrom);
      trainingDateTo.setDate(trainingDateTo.getDate() + 1);
      handleAcademyDocumentFolderValuesChange("trainingDateTo", trainingDateTo);
    }
  }, [academyDocumentFolder?.trainingDateFrom]);

  useEffect(() => {
    if (props.copyOfAcademyFolder) {
      setAcademyDocumentFolder((prevState: any) => ({
        ...prevState,
        title: props.copyOfAcademyFolder?.title,
        description: props.copyOfAcademyFolder?.description,
      }));
    }
  }, [props.copyOfAcademyFolder]);

  useEffect(() => {
    if (props.updateAcademyFolder) {
      setAcademyDocumentFolder(props.updateAcademyFolder);
    }
  }, [props.updateAcademyFolder]);

  useEffect(() => {
    if (academyDocumentFolder?.trainingDateFrom) {
      const suggestedRefreshDate = new Date(
        academyDocumentFolder?.trainingDateFrom
      );
      suggestedRefreshDate.setFullYear(suggestedRefreshDate.getFullYear() + 1);
      handleAcademyDocumentFolderValuesChange(
        "suggestedRefreshDate",
        suggestedRefreshDate
      );
    }
  }, [academyDocumentFolder?.trainingDateFrom]);

  return (
    <Dialog open={props.isDialogOpen} onOpenChange={() => props.onDismiss()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {academyDocumentFolder?.guid
              ? i18n.t<string>("updateAcademyFolderDialogTitle")
              : i18n.t<string>("addAcademyFolderDialogTitle")}
          </DialogTitle>
          <DialogContent>
            {academyDocumentFolder?.guid
              ? i18n.t<string>("updateAcademyFolderDialogText")
              : i18n.t<string>("addAcademyFolderDialogText")}

            <div style={{ flexDirection: "column", display: "flex" }}>
              <Label style={{ marginTop: "15px" }} size="large">
                {i18n.t<string>("title")}
              </Label>
              <Input
                value={academyDocumentFolder?.title}
                onChange={(ev, val) => {
                  handleAcademyDocumentFolderValuesChange(
                    "title",
                    val ? val.value : ""
                  );
                }}
              />
              <Label style={{ marginTop: "15px" }} size="large">
                {i18n.t<string>("category")}
              </Label>
              <Dropdown
                value={i18n.t<string>(
                  academyDocumentFolder?.category
                    ? academyDocumentFolder?.category
                    : ""
                )}
              >
                <Option
                  onClick={() => {
                    handleAcademyDocumentFolderValuesChange(
                      "category",
                      "bohrtechnik"
                    );
                  }}
                  key={"bohrtechnik"}
                >
                  {i18n.t<string>("bohrtechnik")}
                </Option>
                <Option
                  onClick={() => {
                    handleAcademyDocumentFolderValuesChange(
                      "category",
                      "schraubtechnik"
                    );
                  }}
                  key={"schraubtechnik"}
                >
                  {i18n.t<string>("schraubtechnik")}
                </Option>
              </Dropdown>
              <Label style={{ marginTop: "15px" }} size="large">
                {i18n.t<string>("description")}
              </Label>
              <ReactQuill
                style={{ marginTop: "10px" }}
                formats={formats}
                modules={modules}
                theme="snow"
                value={academyDocumentFolder?.description}
                onChange={(val: any) =>
                  handleAcademyDocumentFolderValuesChange(
                    "description",
                    val ? val : ""
                  )
                }
              />
              <div style={{ display: "flex" }}>
                <Field
                  style={{
                    width: "200px",
                    marginRight: "20px",
                    marginTop: "15px",
                  }}
                  size="large"
                  label={i18n.t<string>("trainingDateFrom")}
                >
                  <DatePicker
                    strings={
                      i18n.language.includes("de")
                        ? DayPickerStringsDE
                        : DayPickerStringsEN
                    }
                    value={
                      academyDocumentFolder?.trainingDateFrom
                        ? new Date(academyDocumentFolder?.trainingDateFrom)
                        : new Date()
                    }
                    firstDayOfWeek={0}
                    formatDate={(date?) => {
                      return date ? date.toLocaleDateString() : "";
                    }}
                    onSelectDate={(date) => {
                      if (date) {
                        date?.setHours(12);

                        handleAcademyDocumentFolderValuesChange(
                          "trainingDateFrom",
                          date
                        );
                      }
                    }}
                    placeholder={i18n.t<string>("selectDate")}
                  />
                </Field>
                <Field
                  style={{ marginTop: "15px", width: "200px" }}
                  size="large"
                  label={i18n.t<string>("trainingDateTo")}
                >
                  <DatePicker
                    strings={
                      i18n.language.includes("de")
                        ? DayPickerStringsDE
                        : DayPickerStringsEN
                    }
                    value={
                      academyDocumentFolder?.trainingDateTo
                        ? new Date(academyDocumentFolder?.trainingDateTo)
                        : new Date()
                    }
                    firstDayOfWeek={0}
                    formatDate={(date?) => {
                      return date ? date.toLocaleDateString() : "";
                    }}
                    onSelectDate={(date) => {
                      date?.setHours(12);
                      handleAcademyDocumentFolderValuesChange(
                        "trainingDateTo",
                        date
                      );
                    }}
                    placeholder={i18n.t<string>("selectDate")}
                  />
                </Field>
              </div>
              <Field
                style={{ marginTop: "15px" }}
                size="large"
                label={i18n.t<string>("suggestedRefreshDate")}
              >
                <DatePicker
                  value={
                    academyDocumentFolder?.suggestedRefreshDate
                      ? new Date(academyDocumentFolder?.suggestedRefreshDate)
                      : new Date()
                  }
                  firstDayOfWeek={0}
                  formatDate={(date?) => {
                    return date ? date.toLocaleDateString() : "";
                  }}
                  onSelectDate={(date) => {
                    date?.setHours(12);
                    handleAcademyDocumentFolderValuesChange(
                      "suggestedRefreshDate",
                      date
                    );
                  }}
                  placeholder={i18n.t<string>("selectDate")}
                  strings={
                    i18n.language.includes("de")
                      ? DayPickerStringsDE
                      : DayPickerStringsEN
                  }
                />
              </Field>
              <Field
                style={{ marginTop: "15px" }}
                size="large"
                label={i18n.t<string>("trainer")}
              >
                <LuebPersonaPicker
                  showPicture={false}
                  users={props.luebUsers}
                  selectedUsers={props.luebUsers.filter(
                    (x) =>
                      academyDocumentFolder != undefined &&
                      academyDocumentFolder?.trainerGuid != undefined &&
                      x.fullName != undefined &&
                      academyDocumentFolder?.trainerGuid.includes(x.id)
                  )}
                  onSelectSamAccountName={(userId: string) => {
                    if (userId) {
                      if (!academyDocumentFolder?.trainerGuid) {
                        handleAcademyDocumentFolderValuesChange(
                          "trainerGuid",
                          userId
                        );
                      } else {
                        let trainerGuids =
                          academyDocumentFolder?.trainerGuid + ";" + userId;

                        handleAcademyDocumentFolderValuesChange(
                          "trainerGuid",
                          trainerGuids
                        );
                      }
                    }
                  }}
                  onRemoveSamAccountName={(userId: string) => {
                    if (!academyDocumentFolder?.trainerGuid?.includes(";")) {
                      handleAcademyDocumentFolderValuesChange(
                        "trainerGuid",
                        undefined
                      );
                    } else {
                      var trainerGuids = academyDocumentFolder?.trainerGuid;
                      trainerGuids = trainerGuids.replace(";" + userId, "");
                      trainerGuids = trainerGuids.replace(userId, "");

                      handleAcademyDocumentFolderValuesChange(
                        "trainerGuid",
                        trainerGuids
                      );
                    }
                  }}
                />
              </Field>
            </div>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button
                onClick={() => {
                  props.onDismiss();
                  setAcademyDocumentFolder({
                    category: "bohrtechnik",
                    trainingDateFrom: new Date(),
                    suggestedRefreshDate: new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate() + 1
                    ),
                    trainingDateTo: new Date(
                      new Date().getFullYear() + 1,
                      new Date().getMonth(),
                      new Date().getDate()
                    ),
                    trainerGuid: props.currentUser?.id
                      ? props.currentUser?.id
                      : "",
                  });
                }}
                appearance="secondary"
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogTrigger>
            <Button
              onClick={() => {
                addOrUpdateAcademyFolder();
              }}
              disabled={
                !academyDocumentFolder?.trainerGuid ||
                !academyDocumentFolder.title ||
                !academyDocumentFolder.description
              }
              appearance="primary"
            >
              {academyDocumentFolder?.guid
                ? i18n.t<string>("save")
                : i18n.t<string>("add")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default AddOrUpdateAcademyFolderDialog;
